import { Query } from 'graphql/generated/graphqlTypes';
import { mockDoorHandle1, mockDoorReader1 } from 'mocks/graphqlMocks/doorFixtures';

export function mockedGetVisitorDetailsDoorsData(
  getDoorsForTenant: Query['getDoorsForTenant']
): Pick<Query, 'getDoorsForTenant'> {
  return {
    getDoorsForTenant
  };
}

export const mockedGetVisitorDetailsDoorsDataForQuery = mockedGetVisitorDetailsDoorsData([
  mockDoorReader1,
  mockDoorHandle1
]);
